import { render } from "./Organization.vue?vue&type=template&id=c0bfaff0"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"

import "./Organization.vue?vue&type=style&index=0&id=c0bfaff0&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__